import { Box, Typography, styled, IconButton, Dialog, Tooltip, Button } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, Outlet, useNavigate, useLocation } from "react-router-dom";
import { logout, getUserDetails, getDocRoutes } from "../../services/api";
import { LogOut } from 'lucide-react'



// Assets
import avatarImg from '../../assets/UserImage.svg';
import accountImg from '../../assets/account_circle.svg';
import helpImg from '../../assets/help_center.svg';
import favouriteImg from '../../assets/favorite.svg';
import settingsImg from '../../assets/Vector.svg';
import keyPng from '../../assets/key.png';
import buildingPng from '../../assets/buildings.png';
import docsPng from '../../assets/docs.png';
import dashboardPng from '../../assets/dashboard.png';
import logoutPng from '../../assets/logout.png';
import hamOpenPng from '../../assets/hamOpen.png'
import dropDown from '../../assets/dropDown.png'
// import hamburgerIcon from '../../assets/Hamburger menu.svg'

const initialOptions = [
  { option: "My Venues", icon: buildingPng, url: '/my-venues' },
  { option: "Edit Profile", icon: accountImg, url: "/edit-profile" },
  { option: "Change Password", icon: settingsImg, url: '/change-password' },
];

const Component = styled(Box)(({ collapsed }) => ({
  height: "100vh",
  position: "relative",
  fontFamily: "roboto",
  background: "#fff",
  transition: "width 0.3s ease",
  width: collapsed ? "80px" : "350px",
  borderRight: "1px solid #e5e5e5",
  display: "flex",
  flexDirection: "column",
}));

const Header = styled(Box)({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  padding: "16px",
});

const NameBx = styled(Box)(({ collapsed }) => ({
  padding: collapsed ? "10px" : "12px 16px",
  boxSizing: "border-box",
  height: 78,
  marginTop: 8,
  display: "flex",
  gap: 8,
  alignItems: "center",
  borderBottom: "1px solid #e5e5e5",
  justifyContent: collapsed ? "center" : "flex-start",
  transition: "all 0.3s ease",
}));

const Container = styled(Box)({
  marginTop: 12,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: 8,
});

const Option = styled(Box)(({ collapsed }) => ({
  padding: "10px 16px",
  display: "flex",
  alignItems: "center",
  gap: collapsed ? 0 : 12,
  cursor: "pointer",
  justifyContent: collapsed ? "center" : "flex-start",
  transition: "all 0.3s ease",
}));

const OptionLink = styled(Link)(({ collapsed }) => ({
  textDecoration: "none",
  color: "#181b1b",
  fontSize: 16,
  lineHeight: "25px",
  display: collapsed ? "none" : "inline",
  transition: "opacity 0.2s ease",
  fontWeight: 700
}));

const CancelBtn = styled("button")({
  border: "1px solid #AA4A44",
  borderRadius: 5,
  color: "#AA4A44",
  padding: "8px 12px",
});

const ConfirmBtn = styled("button")({
  background: "#AA4A44",
  borderRadius: 5,
  color: "#fff",
  padding: "8px 12px",
});

const MainWrapper = styled("div")({
  display: "flex",
  gap: "24px",
});

const RightSideComponent = styled("div")({
  flex: 2
});

const Profile = () => {
  const navigate = useNavigate();
  const [confirmation, setConfirmation] = useState(false);
  const [user, setUser] = useState();
  const [options, setOptions] = useState(initialOptions);
  const [collapsed, setCollapsed] = useState(false);
  const [docsOpen, setDocsOpen] = useState(false);

  const location = useLocation();


  useEffect(() => {
    const fetchData = async () => {
      let response = await getUserDetails({ userId: localStorage.getItem("userId") });
      if (response.status === 200) {
        setUser(response.data);
        if (response.data.roles.includes("admin")) {
          let alldocs = await getDocRoutes()
          let dynamicChilds = alldocs?.data?.map(elm => ({
            name: elm?.subject,
            url: `/documentations/v1/${elm.title}`
          }))
          setOptions((prev) => [
            { option: "Dashboard", icon: dashboardPng, url: "/" },
            { option: "API keys", icon: keyPng, url: "/api-keys" },
            {
              option: "Docs", icon: docsPng, url: "/documentations", children: dynamicChilds
                // { name: "SDK Guide", url: "/docs/sdk" },
                // { name: "Changelog", url: "/docs/changelog" },
            },
            { option: "User Monitoring", icon: docsPng, url: "/app-details" },
            ...prev,
          ]);
        }
      }
    };

    fetchData();
    return () => setOptions((prev) => prev.filter((opt) => opt.option !== "API keys"));
  }, []);

  const handleLogout = () => setConfirmation(true);
  const handleClose = () => setConfirmation(false);

  const handleConfirm = async () => {
    let response = await logout({ refreshToken: localStorage.getItem("refreshToken") });
    if (response.status) {
      localStorage.clear();
      alert("Logged out successfully");
      navigate("/auth/signin");
    }
  };

  useEffect(() => {
    if (location.pathname.startsWith("/docs")) {
      setDocsOpen(true);
    }
  }, [location.pathname]);




  return (
    <MainWrapper>
      {/* LEFT SIDE - Collapsible Account Panel */}
      <Component collapsed={collapsed ? 1 : 0}>
        <Header>
          {!collapsed && (
            <Typography
              sx={{
                fontSize: 20,
                fontWeight: 700,
                color: "#181b1b",
              }}
            >
              Account
            </Typography>
          )}
          <IconButton onClick={() => setCollapsed(!collapsed)}>
            {/* {collapsed ? <MenuOpenIcon /> :  <MenuIcon />} */}
            <img width={50} style={{ transform: collapsed ? "rotate(270deg)" : 'rotate(90deg)' }} src={dropDown} />
          </IconButton>
        </Header>

        <NameBx collapsed={collapsed ? 1 : 0}>
          <Box sx={{ width: 54, height: 54 }}>
            <img
              src={avatarImg}
              alt="User avatar"
              style={{ width: "100%", height: "100%", borderRadius: "50%" }}
            />
          </Box>
          {!collapsed && (
            <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
              <Typography sx={{ fontWeight: 500, fontSize: 16 }}>{user?.name}</Typography>
              <Typography sx={{ fontSize: 12, color: "#555" }}>
                {user?.email || user?.mobile}
              </Typography>
            </Box>
          )}
        </NameBx>

        <Container>
          {options?.map((elm) => {
            const isActiveMain = elm.url && location.pathname === elm.url;

            return (
              <Box key={elm.option} sx={{ width: "100%" }}>

                {/* MAIN MENU ITEM */}
                <Tooltip title={collapsed ? elm.option : ""} placement="right">
                  <Option
                    collapsed={collapsed ? 1 : 0}
                    onClick={() => {
                      if (elm.children) {
                        setDocsOpen(!docsOpen);
                      } else {
                        navigate(elm.url);
                      }
                    }}
                    sx={{
                      background: isActiveMain ? "#f0f6ff" : "transparent",
                      borderLeft: isActiveMain ? "4px solid #1976d2" : "4px solid transparent",
                      transition: "0.2s",
                    }}
                  >
                    <img width={25} src={elm.icon} alt={elm.option} />

                    <OptionLink collapsed={collapsed ? 1 : 0} to={elm.url || "#"}>
                      {elm.option}
                    </OptionLink>

                    {/* Expand arrow */}
                    {!collapsed && elm.children && (
                      <img
                        src={dropDown}
                        width={14}
                        style={{
                          transform: docsOpen ? "rotate(180deg)" : "rotate(0deg)",
                          transition: "0.2s",
                        }}
                      />
                    )}
                  </Option>
                </Tooltip>

                {/* SUBMENU */}
                {!collapsed && elm.children && docsOpen && (
                  <Box
                    sx={{
                      ml: 8,
                      mt: 0.5,
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    {elm.children.map((child) => {
                      const isActiveSub = location.pathname === child.url;

                      return (
                        <Box
                          key={child.name}
                          onClick={() => navigate(child.url)}
                          sx={{
                            cursor: "pointer",
                            fontSize: 14,
                            fontWeight: 600,
                            padding: "6px 8px",
                            // borderRadius: 2,
                            background: isActiveSub ? "#e7f1ff" : "transparent",
                            color: isActiveSub ? "#0a66c2" : "#444",
                            borderLeft: isActiveSub ? "4px solid #1976d2" : "4px solid transparent",

                            "&:hover": { color: "#000" },
                            transition: "0.2s",
                          }}
                        >
                          {child.name}
                        </Box>
                      );
                    })}
                  </Box>
                )}
              </Box>
            );
          })}


          {!collapsed ? <Button
            onClick={handleLogout}
            startIcon={<img style={{ width: 16 }} src={logoutPng} />}
            variant="outlined"
            sx={{
              mt: 1,
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              marginLeft: 2
            }}
          >

            Sign out
          </Button>
          :
          <LogOut onClick={handleLogout} />
          }



        </Container>

        <Dialog open={confirmation} onClose={handleClose}>
          <Box sx={{ padding: "12px 16px" }}>
            <Typography sx={{ fontWeight: 700, marginBottom: 1 }}>
              Are you sure you want to log out?
            </Typography>
            <Box sx={{ display: "flex", gap: 1.5, marginTop: 2 }}>
              <CancelBtn onClick={handleClose}>Cancel</CancelBtn>
              <ConfirmBtn onClick={handleConfirm}>Confirm</ConfirmBtn>
            </Box>
          </Box>
        </Dialog>
      </Component>

      {/* RIGHT SIDE */}
      <RightSideComponent>
        <Outlet />
      </RightSideComponent>
    </MainWrapper>
  );
};

export default Profile;
